<template>
	<div class="property bg-gray-100 rounded-xl p-8" id="propertyId">
		<div v-if="!isLoading">
			<div class="prop-nav-container sticky">
				<scrollactive active-class="active" :scrollOffset="-50" id="propNav" class="property-navigation">
					<a v-if="!isNotAssessed" href="#Property_Summary" class="scrollactive-item header5 prop-nav">Property Summary</a>
					<a v-if="!isNotAssessed" href="#Property_Assessment" class="scrollactive-item header5 prop-nav">Property Assessment</a>
					<a v-if="!isNotAssessed" href="#Neighborhood_Analysis" class="scrollactive-item header5 prop-nav">Neighborhood Analysis</a>
					<a v-if="!isNotAssessed" href="#Property_Result" class="scrollactive-item header5 prop-nav">Results</a>
					<!-- javascript 0 -->
					<a href="javascript:void(0)" v-on:click="openShareModal" class="scrollactive-item header5 prop-nav share-one">
						<i class="material-icons">share</i>Share
					</a>
					<transition name="fade" appear>
						<div class="modal-overlay" v-if="showShareModal" v-on:click="cancelForm"></div>
					</transition>
				</scrollactive>
				<!--  -->
				<!-- javascript 0 -->
				<a href="javascript:void(0)" v-on:click="openShareModal" class="scrollactive-item header5 prop-nav share-one mobile">
					<i class="material-icons">share</i>Share
				</a>
				<transition name="fade" appear>
					<div class="modal-overlay" v-if="showShareModal" v-on:click="cancelForm"></div>
				</transition>
			</div>
			<!--  -->
			<transition name="fade" appear>
				<div class="modal" v-if="showShareModal">
					<form class="container" action="#">
						<div class="header2">Email this property</div>
						<br />
						<br />
						<div class="modal-form-input-cont">
							<InputBox placeHolder="Recipient email" v-model="form.recipientEmail" inputStyleType="sharp" />
							<InputBox placeHolder="Your email" v-model="form.yourEmail" inputStyleType="sharp" />
							<div class="sharp input-box">
								<div class="input-cont">
									<textarea placeholder="Include message (Optional)" v-model="form.message"></textarea>
								</div>
							</div>
						</div>
						<div class="modal-button-cont">
							<Button title="Cancel" buttonType="outline" :onClick="cancelForm" />
							<Button title="Send email" :onClick="submit" />
						</div>
					</form>
				</div>
			</transition>
			<!--  -->
			<PropertySummary />
			<PropertyAssessment v-if="!isNotAssessed" />
			<PropertyMap v-if="!isNotAssessed" />
			<PropertyResults v-if="!isNotAssessed" />
			<SubscriptionAndForms v-if="isNotAssessed" />
		</div>
		<div v-if="isLoading">Loading..</div>
	</div>
</template>


<script>
// @ is an alias to /src
import PropertySummary from "@/components/property/PropertySummary.vue";
import PropertyAssessment from "@/components/property/PropertyAssessment.vue";
import PropertyMap from "@/components/property/PropertyMap.vue";
import PropertyResults from "@/components/property/PropertyResults.vue";
import localData from "@/store/utils/localdata";
import ScrollToLink from "@/components/ui/ScrollToLink.vue";
import { assessmentStatus } from "@/env";
import PropMapInfoElement from "@/components/property/PropMapInfoElement.vue";
import NeighborhoodAnalysis from "@/components/property/NeighborhoodAnalysis.vue";
import SubscriptionAndForms from "@/components/property/SubscriptionAndForms.vue";
import InputBox from "@/components/ui/InputBox.vue";
import Button from "@/components/ui/Button.vue";
import { SHARE_PROP } from "@/store/constants";

import Vue from "vue";
import VueScrollactive from "vue-scrollactive";

Vue.use(VueScrollactive);

export default {
	name: "property",
	components: {
		ScrollToLink,
		PropertySummary,
		PropertyAssessment,
		PropertyMap,
		PropMapInfoElement,
		PropertyResults,
		NeighborhoodAnalysis,
		SubscriptionAndForms,
		InputBox,
		Button,
	},
	data() {
		return {
			isLoading: true,
			currentData: {
				pin: "",
				address: "",
			},
			isActive: false,
			activeSection: "Property_Summary",
			showShareModal: false,
			form: {
				recipientEmail: "",
				yourEmail: "",
				message: "Check out this property tax analysis from Garbur.",
			},
			propertyURL: "",
		};
	},
	mounted() {
		this.isLoading = true;
		const data = this.$route.params;
		this.$store.dispatch("getPropertyById", data).then((property) => {
			// set localStorage for currentData
			localData.setItem("currentData", JSON.stringify({ pin: property.pin, address: property.address, propertyId: data.id }));
			this.currentData = property;

			//window get update document title dynamically
			window.document.title = "Property Details - PIN # " + property.pin;

			this.isLoading = false;
		});

		// get property URL for share
		this.propertyURL = window.location.href;
	},
	methods: {
		callStickyNav() {
			var propNav = document.getElementById("propNav");

			// Get the offset position of the navbar
			// var sticky = propNav.offsetTop;
			var sticky = 105;

			if (window.pageYOffset >= sticky) {
				propNav.classList.add("sticky");
			} else {
				propNav.classList.remove("sticky");
			}
		},
		openShareModal() {
			this.showShareModal = true;
		},
		cancelForm() {
			this.showShareModal = false;
		},
		isFormValid() {
			if (!this.form.recipientEmail) {
				return false;
			} else if (!this.form.yourEmail) {
				return false;
			} else if (!this.form.message) {
				return false;
			}
			return true;
		},

		async submit() {
			if (!this.isFormValid()) {
				this.$toast.open({
					message: "Missing fields",
					position: "top",
					type: "error",
				});
			} else {
				this.showShareModal = false;
				this.showToastAlert = true;
				const shareProperty = {
					recipientEmail: this.form.recipientEmail,
					yourEmail: this.form.yourEmail,
					message: this.form.message,
					propertyId: this.$route.params.id,
					propertyURL: this.propertyURL,
				};
				try {
					const result = await this.$store.dispatch(SHARE_PROP, shareProperty);
					if (result) this.setSharedTrue();
				} catch (ex) {
					this.$toast.open({
						message: "Error happened when send share",
						position: "top",
						type: "error",
					});
				}
			}
		},
		setSharedTrue() {
			this.form = {
				recipientEmail: "",
				yourEmail: "",
				message: "",
			};
		},
	},

	created() {
		window.addEventListener("scroll", this.callStickyNav);
	},
	destroyed() {
		window.removeEventListener("scroll", this.callStickyNav);
	},

	computed: {
		property() {
			return this.$store.getters.getAllPropertyData;
		},
		assessmentStatusValue() {
			return assessmentStatus;
		},
		isNotAssessed() {
			return this.$store.getters.getAssessmentRate === assessmentStatus.notAssessed; //"Not Assessed";
		},
	},
};
</script>
<style lang="scss">
.property {
	.prop-nav-container {
		background: var(--dark-blue);
		height: 55px;
		border-bottom: 5px solid #c0c0c0;
	}
	.property-navigation {
		// background: var(--dark-blue);
		// height: 56px;
		display: flex;
		align-items: center;
		column-gap: 25px;
		padding: 0 60px;
		// border-bottom: 5px solid #c0c0c0;
		max-width: 1600px;
		margin: 0 auto;
		.header5 {
			font-style: normal;
			font-weight: normal;
			font-size: 14px;
			line-height: 21px;
			color: #ffffff;
		}
		.prop-nav {
			text-decoration: none;
			line-height: 55px;
			border-bottom: 5px solid transparent;
		}
		.share-one {
			display: flex;
			flex-direction: row;
			align-items: center;
		}
		.prop-nav.active,
		.prop-nav:hover {
			border-bottom: 5px solid var(--accent);
			// padding-top: 5px;
		}
		.prop-nav:last-child {
			margin-left: auto;
			cursor: pointer;
		}
	}
	.mobile {
		display: none;
	}
	//
	.snap-container {
		scroll-snap-type: y mandatory;
		.child {
			scroll-snap-align: start;
		}
	}
	.sticky {
		position: sticky;
		top: 0;
		z-index: 999;
	}
	/// Share Form modal
	.modal-overlay {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 98;
		background-color: rgba(0, 0, 0, 0.3);
		backdrop-filter: blur(3px);
	}
	.modal {
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 9999999999;
		width: 100%;
		max-width: 690px;
		background-color: #fff;
		padding: 25px;
		.header2 {
			color: #c4c4c4;
			font-size: 31px;
			padding-top: 20px;
		}
		.modal-form-input-cont {
			margin-left: 96px;
			.sharp.input-box {
				margin: 15px auto;
				.input-cont {
					position: relative;
					display: flex;
				}
				.input-cont textarea {
					border: 1px solid #dbdee7;
					box-sizing: border-box;
					border-radius: 6px;
					// width: 290px;
					height: 60px;
					font-family: Poppins;
					font-style: normal;
					font-weight: 300;
					font-size: 16px;
					line-height: 200%;
					color: var(--black);
					text-align: left;
					padding-left: 15px;
					outline: none;
					max-width: 500px;
					width: 100%;
				}
				textarea::placeholder {
					font-family: "Poppins";
					font-style: italic;
					color: var(--text);
				}
			}
		}
		.modal-button-cont {
			width: 52%;
			max-width: 358px;
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			margin-top: 25px;
			margin-left: 96px;
			margin-bottom: 20px;
			.outline {
				border: 1px solid var(--accent);
				color: var(--accent);
				background-color: transparent;
			}
			.button {
				width: 170px;
				height: 48px;
			}
		}
	}
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.5s;
	}
	.fade-enter,
	.fade-leave-to {
		opacity: 0;
	}
}
@media screen and (max-width: 768px) {
	.property {
		height: unset;
		scroll-snap-type: unset;
		overflow: unset;
		.property-navigation {
			display: none;
		}
		.mobile {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: flex-end;
			text-decoration: none;
			padding: 15px;
		}
		.modal {
			width: 80%;
			.modal-form-input-cont {
				margin: unset;
			}
		}
	}
}
</style>
